import CrashScreen from "./CrashScreen";
export default CrashScreen;
